module.exports = __webpack_public_path__ + "static/media/KUZMA CAR-60.497fd904.png";